export function formatGbp(value) {
  if (value === null || value === undefined || Number.isNaN(value)) return null;
  return `£${value.toLocaleString("en-GB", { maximumFractionDigits: 2 })}`;
}
